
import { getIndustryReports } from '@/api/enterprise'
import axios from 'axios'
import dayjs from 'dayjs'
export default {
  props: {
    columns: {
        type: Array,
        default: () => []
    }
  },
  data() {
    return {
        tableLoading: false,
        tableData: [],  
        list: [],
        title: '',
        page: 1,
        total: 10,   
        isTable : 0   
    }
  },
  methods: {
    changePage(page) {
      this.page = page
      this.isTable = 1
      this.fetchData(this.route, this.page)
    }, 
    switchPage(totalPages, currentPage) {
        if (totalPages <= 0) {
            throw new Error("Total pages should be greater than zero.");
        }

        if (currentPage < 1 || currentPage > totalPages) {
            throw new Error("Current page should be within the range from 1 to total pages.");
        }

        if (currentPage === totalPages) {
            return 1;
        } else if (currentPage == 0) {
            return 1;
        }
        else {
            return Math.round((totalPages / 10)) - currentPage + 1;
        }
    },
    async getList(route, page) {
      this.tableLoading = true
      this.isTable = 0
      this.route = route
      const res = await axios.get(`${process.env.NODE_ENV === 'pro'? 'https://www.gdpcpg.com':'/apic'}/api/${route}/service.xhtml?appKey=cd66d915a68f462a975aaac8e077847f&page=${this.switchPage(this.total, page)}&rows=9&startDate=20210101&endDate=${dayjs().format('YYYYMMDD')}`)        
      this.tableLoading = false
      if (res) {
        this.tableData = res.data.data
      }
      
    },
    async getTotalList(route) {
      this.tableLoading = true
      this.isTable = 0
      this.route = route
      const res = await axios.get(`${process.env.NODE_ENV === 'pro'? 'https://www.gdpcpg.com':'/apic'}/api/${route}/service.xhtml?appKey=cd66d915a68f462a975aaac8e077847f&page=1&rows=1&startDate=20210101&endDate=${dayjs().format('YYYYMMDD')}`)        
      this.tableLoading = false
      this.total = res.data.total      
    },
    async getTotal(route) {
      await this.getTotalList(route, 1)
      setTimeout( async () => {
        await this.fetchData(route, 1)
      })  
          
    },
    async fetchData(route, page=1) {       
        if (route == '/common/getIndustryReports' || route == '/common/getIndustryReports1') {
          if (route == '/common/getIndustryReports1') {
            this.isTable = 2
          } else {
            this.isTable = 1
          }          
          const res = await getIndustryReports({})
          if (res) {
            this.list = res.data
          }
          
        } else {  
          this.page = page                 
          await this.getList(route, page)
        }    
        
    },
  }
}
